import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Patrimony } from '../shared/interfaces/patrimony.interface';

@Injectable({
  providedIn: 'root'
})
export class PatrimonyService {

  constructor(private http: HttpClient) { }

  baseUrl = '@cec-api/patrimony/';

  get():Promise<any>{
    return this.http.get(this.baseUrl).toPromise();
  }

  getById(id: number): Promise<any>{
    return this.http.get(this.baseUrl+id).toPromise();
  }

  add(patrimony: Patrimony): Promise<any>{
    return this.http.post(this.baseUrl, patrimony).toPromise();
  }

  update(user: Patrimony, id: number): Promise<any>{
    return this.http.put(this.baseUrl+id, user).toPromise();
  }

  delete(id:number){
    return this.http.delete(this.baseUrl+id).toPromise();
  }

  search(searchValue: string):Promise<any>{
    return this.http.get(this.baseUrl+'search?name='+ searchValue).toPromise();
  }
}
